import React from "react";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import injecSolution1 from "../../../assets/technology/injecSolu/injecSolu1.png";
import injecSolution2 from "../../../assets/technology/injecSolu/injecSolu2.png";

const InjecSolution = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        maxWidth: "100%",
        flexDirection: "column",
        width: { xs: "100%", sm: "100%" },
        // pt: { xs: 2, sm: 10 },
        // pb: { xs: 2, sm: 10 },
      }}
    >
      <Typography
        component="h1"
        variant="h1"
        sx={{
          display: "flex",
          //  flexDirection: { xs: "column", md: "row" },
          justifyContent: "start",
          alignSelf: "start",
          textAlign: "start",
          fontSize: { xs: "4rem", sm: "3rem" },
          borderBottom: "2px solid black",
          width: "100%",
          borderBottomWidth: "2px",
        }}
      >
        Intelligent layered water injection Solution
      </Typography>
      <Box>
        {/* </Roll> */}
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            lineHeight: "1.6", // Adjust the line height value as needed
            letterSpacing: "0.5px", // Adjust the letter spacing value as needed
            fontWeight: "bold", // Adjust the font weight value as needed (e.g., 'bold', 'normal', etc.)
            fontSize: "16px",
            paddingTop: "20px",
            // gap: "20px", // Add gap between the images
            // padding: "20px", // Add padding around the images
            //  width: { xs: "100%", sm: "50%",md:"100%" },
          }}
        >
          Cabled Intelligent Water Injection Solution
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            lineHeight: "2", // Adjust the line height value as needed
            letterSpacing: "0.5px", // Adjust the letter spacing value as needed
            fontWeight: "bold", // Adjust the font weight value as needed (e.g., 'bold', 'normal', etc.)
            fontSize: "13px",
            paddingTop: "20px",
            // gap: "20px", // Add gap between the images
            // padding: "20px", // Add padding around the images
            //  width: { xs: "100%", sm: "50%",md:"100%" },
          }}
        >
          （1）Each water injection layer is equipped with a cabled intelligent
          injection regulator, and separated by a cable through packer; <br />{" "}
          （2）The surface control unit can long-term monitor down hole flow,
          temperature, water injection pressure and formation pressure, and
          obtain the total amount of injected water in each layer in real time;
          <br />
          （3）Real-time monitoring of the water injection volume of each layer,
          real-time regulation of the valve opening, and control of the water
          injection volume within the allowable error;
          <br /> （4）It can communicate with the remote control room, realize
          the real-time detection or reset of the water injection volume of each
          layer, check the pressure and temperature of the water injection
          layer, and check the sealing performance of the packer；
          <br /> （5）The wellhead intelligent calibration self-tester
          instrument can periodically re-calibrate and calibrate the parameters
          of the down hole water injection regulator;
          <br /> （6）The number of water injection stages is not
          limited.Suitable for vertical well, highly deviated well and deep
          well.
        </Typography>
        <Box>
          <img
            src={injecSolution1}
            alt=" Vertical and Directional Well Water Control Solution"
            style={{
              display: "block", // Ensures the image is treated as a block element
              margin: "auto", // Center the image horizontally
              // width: '70%',    // Ensure the image takes the full width of its container
              height: "auto", // Maintain aspect ratio
              maxWidth: "100%", // Ensure the image doesn't exceed the container width
            }}
          />
        </Box>
      </Box>
      <Box>
        {/* </Roll> */}
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            lineHeight: "1.6", // Adjust the line height value as needed
            letterSpacing: "0.5px", // Adjust the letter spacing value as needed
            fontWeight: "bold", // Adjust the font weight value as needed (e.g., 'bold', 'normal', etc.)
            fontSize: "16px",
            paddingTop: "20px",
            // gap: "20px", // Add gap between the images
            // padding: "20px", // Add padding around the images
            //  width: { xs: "100%", sm: "50%",md:"100%" },
          }}
        >
          Cableless Intelligent Water Injection Solution
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            lineHeight: "2", // Adjust the line height value as needed
            letterSpacing: "0.5px", // Adjust the letter spacing value as needed
            fontWeight: "bold", // Adjust the font weight value as needed (e.g., 'bold', 'normal', etc.)
            fontSize: "13px",
            paddingTop: "20px",
            // gap: "20px", // Add gap between the images
            // padding: "20px", // Add padding around the images
            //  width: { xs: "100%", sm: "50%",md:"100%" },
          }}
        >
          1）The cableless intelligent water injection system realizes two-way
          communication between the surface and the down hole through the
          pressure and flow carrier technology without the requirement of cable
          operation, low investment, and is the real wireless transmission；
          <br />
          （2）The dual detection method of pressure and flow carrier improves
          the accuracy and timeliness of decoding, greatly reduces the bit error
          rate, and effectively improves the reliability of wave code
          communication； <br />
          （3）Through the remote monitoring platform, he can monitor the down
          hole layered flow, layered water injection pressure, formation
          pressure, temperature and other parameters of the water injection well
          in real time；
          <br /> （4）It can realize the coordinated communication and control
          of the down hole, ground and base, and realize the layered measurement
          and adjustment of water injection wells, well management and dynamic
          monitoring without the need of other supporting equipment and
          personnel；
          <br /> （5）Low power consumption, 3-year power consumption is less
          than 60% of the total battery power；
          <br />
          （6）There is no need of down hole cable operation, the risk of
          completion work is low； <br />
          （7）It is suitable for vertical well, highly deviated well and
          horizontal well with few injection stages and shallow well depth；{" "}
          <br />
          （8）When the number of water injection layers is large and the
          permeability coefficient is not uniform, it is difficult to regulate
          the cableless intelligent water injection regulator.
        </Typography>

        <Box>
          <img
            src={injecSolution2}
            alt="Horizontal new well Water Control Solution"
            style={{
              display: "block", // Ensures the image is treated as a block element
              margin: "auto", // Center the image horizontally
              // width: '70%',    // Ensure the image takes the full width of its container
              height: "auto", // Maintain aspect ratio
              maxWidth: "100%", // Ensure the image doesn't exceed the container width
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default InjecSolution;
